<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle27')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle27') }}</h1>
    <p>{{ $t('artText27-1') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Contemporary_Design_Trends_Implement_Any_Ideas_with_an_Innovative_Application.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText27-2') }}</h2>
    <p>{{ $t('artText27-3') }}</p>
    <h2>{{ $t('artText27-4') }}</h2>
    <p>{{ $t('artText27-5') }}</p>
    <h2>{{ $t('artText27-6') }}</h2>
    <p>{{ $t('artText27-7') }}</p>
    <h2>{{ $t('artText27-8') }}</h2>
    <p>{{ $t('artText27-9') }}</p>
    <h2>{{ $t('artText27-10') }}</h2>
    <p>{{ $t('artText27-11') }}</p>
    <img
      :src="`${staticUrl}/images/blog/Contemporary_Design_Trends_Implement_Any_Ideas_with_an_Innovative_Application_1.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText27-12') }}</h2>
    <p>{{ $t('artText27-13') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle27')}`,
  ogTitle: `${t('artSeoTitle27')}`,
  description: `${t('artSeoDesc27')}`,
  ogDescription: `${t('artSeoDesc27')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
